
import { defineComponent } from 'vue'
import KanbanTaskList from '@/components/KanbanTaskList.vue'
import KanbanAddForm from '@/components/KanbanAddForm.vue'
import ActionButton from './ActionButton.vue'
import { createListService } from '@/services/list'
import { mapState } from 'vuex'
export default defineComponent({
  components: {
    KanbanTaskList,
    KanbanAddForm,
    ActionButton
  },
  data () {
    return {
      showAddForm: false
    }
  },
  methods: {
    async handleCreateList (name: string) {
      this.showAddForm = false
      const res = await createListService(this.$route.params.boardId, { name: name })
      if (!res.error) {
        this.$store.commit('ADD_CURRENTBOARD_LIST', res.data)
        this.$store.commit('UPDATE_WORKSPACE_BOARDS')
      }
    }
  },
  computed: {
    ...mapState({
      currentBoard: 'currentBoard'
    })
  }
})
